import { ElementRef } from '@angular/core';
import { PlaybackService, PlaybackSession, AssetResolution, HTMLMediaPlaybackSession, PlaybackHints, PlaybackItem } from 'media-playback';
import { Injectable } from '@angular/core';
import { AvAsset } from 'models';
//import * as Hls from 'hls.js';

declare let Hls : any; // TODO: fix this after hls.js can support SSR

/**
 * HLS playback service
 */
@Injectable()
export class HTMLVideoPlaybackService implements PlaybackService {

    constructor() {
    }

    get id() { 
        return 'html-video'; 
    }

    resolve(item : PlaybackItem) : AssetResolution {
        let asset : AvAsset = item.item.asset;
        let url = asset.url;

        if (!url.endsWith('.mp4'))
            return null;
        
        return {
            item,
            service: this,
            asset,
            data: {}
        };
    }

    /**
     * Play the given media resolution within the given root element.
     */
    async play(mediaResolution : AssetResolution, rootElement : ElementRef, hints? : PlaybackHints) : Promise<PlaybackSession> {
        let assetUrl = mediaResolution.asset.url;
        let video = document.createElement('video');

        if (!hints)
            hints = {};
            
        let autoplay = hints.autoplay !== false;
        video.controls = false;
        video.autoplay = autoplay;
        video.src = assetUrl;

        rootElement.nativeElement.appendChild(video);
  
        return new HTMLMediaPlaybackSession(mediaResolution.item, this, video, mediaResolution.asset, hints.startPosition || 0);
    }
}
